import { createRouter, createWebHistory } from 'vue-router';
import { modalLoginSSO } from '../utils/sso';
import { getDataUser } from '../utils/index';
import routesApp, { isPermissionRoute } from './routes';

const NotFound = {
  template: `<div class="box-full-page-text"><h1>Rota não configurada</h1></div>`,
};
const Forbiden = {
  template: `<div class="box-full-page-text"><h1>É preciso fazer o login para continuar...</h1></div>`,
};
const WithoutPermission = {
  template: `<div class="box-full-page-text"><h1>Sem permissão para acessar essa página...</h1></div>`,
};

const routes = [
  { path: '/forbiden', name: 'Forbiden', component: Forbiden },
  {
    path: '/withoutPermission',
    name: 'WithoutPermission',
    component: WithoutPermission,
  },
  {
    path: '/:catchAll(.*)',
    component: NotFound,
  },
];

routesApp.forEach((route) => {
  if (route.submenu) {
    route.submenu.forEach((subRoute) => {
      routes.push({
        path: subRoute.path,
        name: subRoute.name,
        component: subRoute.component,
        key: route.uniqueKey,
      });
    });
  } else
    routes.push({
      path: route.path,
      name: route.name,
      component: route.component,
      key: route.uniqueKey,
    });
});

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  mode: 'history',
});

export const addGuardRoutes = () => {
  router.beforeEach(async (to, from, next) => {
    const dataUser = getDataUser();
    const isAuthenticated = dataUser.isAuthenticated;
    const isNotPermission = isPermissionRoute(dataUser, to);

    if (to.name !== 'WithoutPermission' && isAuthenticated && !isNotPermission) {
      next({ name: 'WithoutPermission' });
    } else if (to.name !== 'Forbiden' && !isAuthenticated) {
      modalLoginSSO();
      next({ name: 'Forbiden' });
    } else next();
  });
};

export default router;
